import { FuncResponse, FuncResponseType, FunctionBase, RunStreamResponse, } from "../../storyV2/function/FunctionBase";
import isBlank from "@sedan-utils/is-blank";
import { StudioProjectV3MidjourneyValue } from "../../project/domain/StudioProjectAttributesV3NodeData";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
import { settings } from "../../kernel/Settings";
export class MidjourneyFunction extends FunctionBase {
    constructor(brainClient, authStore, meStore, messageCenter, topicService) {
        super(brainClient, authStore);
        this.brainClient = brainClient;
        this.authStore = authStore;
        this.meStore = meStore;
        this.messageCenter = messageCenter;
        this.topicService = topicService;
    }
    async run(input, identityInfo, variableList = [], page = 1, next = undefined, pagination = undefined, requestParams = {}, checkAbort) {
        const midjourneyV2 = await this.meStore.hasMidjourneyV2Permission();
        if (midjourneyV2) {
            const topic = await this.topicService.generateTopic(identityInfo, "midjourneyV2");
            const runStreamResponse = new RunStreamResponse();
            const pollingPromise = new Promise((resolve, reject) => {
                this.brainClient.openAi
                    .midjourney(input, topic, FunctionUtil.createAbortUuid(identityInfo))
                    .then(res => {
                    const midjourneyValue = new StudioProjectV3MidjourneyValue();
                    midjourneyValue.loading = true;
                    runStreamResponse.receive(midjourneyValue, false);
                    const msgId = res.data.data.messageId;
                    setTimeout(() => {
                        this.pollingMessage(msgId, topic, runStreamResponse, resolve, reject, identityInfo, checkAbort);
                    }, 25000);
                })
                    .catch(error => reject(error));
            });
            const socketPromise = new Promise((resolve, reject) => {
                this.messageCenter.on(topic, (res) => {
                    const imageUrl = res.imageUrls[0];
                    if (imageUrl) {
                        this.messageCenter.off(topic);
                        const midjourneyValue = new StudioProjectV3MidjourneyValue();
                        midjourneyValue.loading = false;
                        midjourneyValue.value = imageUrl;
                        runStreamResponse.receive(midjourneyValue, true);
                        resolve(imageUrl);
                    }
                }, `${identityInfo?.projectId}_${identityInfo?.edgeId}`);
            });
            Promise.race([pollingPromise, socketPromise])
                .then(() => {
                return Promise.resolve();
            })
                .catch(error => {
                runStreamResponse.receive({}, true, error);
            });
            return new FuncResponse(FuncResponseType.MIDJOURNEY, runStreamResponse);
        }
        const imgUrl = await this.requestStableai(input, "midjourney");
        return new FuncResponse(FuncResponseType.TEXT, imgUrl);
    }
    async requestStableai(prompt, from) {
        const result = await this.brainClient.openAi.stableai(prompt, from);
        const s3url = result.data.s3_path || "";
        const url = `${settings.S3CDN}${encodeURI(s3url)}`;
        return url;
    }
    pollingMessage(msgId, topic, runResponse, resolve, reject, identityInfo, checkAbort) {
        if (checkAbort && checkAbort()) {
            reject();
            return;
        }
        this.brainClient.openAi
            .midjourneyMessage(msgId, FunctionUtil.createAbortUuid(identityInfo))
            .then(res => {
            const progress = res.data.data?.progress ?? "0";
            const midjourneyValue = new StudioProjectV3MidjourneyValue();
            if (progress === "100") {
                const imageUrl = res.data.data?.response?.imageUrls?.first() ?? "";
                if (!isBlank(imageUrl)) {
                    this.messageCenter.off(topic);
                    midjourneyValue.loading = false;
                    midjourneyValue.polling = false;
                    midjourneyValue.value = imageUrl;
                    runResponse.receive(midjourneyValue, true);
                    resolve(imageUrl);
                }
            }
            else {
                midjourneyValue.loading = true;
                midjourneyValue.polling = true;
                midjourneyValue.progress = progress;
                runResponse.receive(midjourneyValue, false);
                setTimeout(() => {
                    this.pollingMessage(msgId, topic, runResponse, resolve, reject, identityInfo, checkAbort);
                }, 5000);
            }
        })
            .catch(error => {
            this.messageCenter.off(topic);
            const midjourneyValue = new StudioProjectV3MidjourneyValue();
            midjourneyValue.loading = false;
            midjourneyValue.polling = false;
            midjourneyValue.value = "";
            runResponse.receive(midjourneyValue, true, error);
        });
    }
}
